<script>
export default {
	props: {
		data: {
			type: String,
			required: false
		},
	},	
	data() {
		return {
			show: false,
			image: ""
		}
	},
	methods: {
		capturarImagen(event) {
			let file = event.target.files;
			let vm = this;
			try {
				var reader = new FileReader();
				reader.onload = function (event) {
					let fileContent = event.target.result;
					vm.image = fileContent;
					vm.$emit('capturaImagen', vm.image);
				};
				reader.readAsDataURL(file[0]);
			}
			catch(error) {
				console.log(error);
			}
			this.show = true;
		},
		deletePreview() {
			this.image = "";
			this.show = false;
		}
	},
}
</script>

<template>
	<div class="upload-image">
		<label 
			class="upload-image-label" 
			for="input-file" 
			v-if="!show"
		>
			<span class="upload-image-label-icon">
				<font-awesome-icon icon="fa-solid fa-arrow-up-from-bracket" class="color-secondary"></font-awesome-icon>
			</span>
			<input
				type="file"
				id="input-file"
				@change="capturarImagen($event)"
				accept="image/jpeg, image/png, image/jpg"
				style="display: none"
			/>
			<span class="upload-image-label-text">
				Haz clic aquí<br> 
				<small>para seleccionar una imagen</small>
			</span>
		</label>
		<div 
			class="upload-image-preview" 
			v-if="show"
		>
			<a 
				@click="deletePreview()"
				href="javascript:"
				class="upload-image-preview-remove"   
			>
				<font-awesome-icon icon="fa-solid fa-xmark"></font-awesome-icon>
			</a>
			<img 
				id="preview-img"
				class="upload-image-preview-img"
				:src="image"/>
		</div>
	</div>
</template>
